import React from 'react';

const PostsCountInfo = ({ 
    displayPosts, 
    displayTotal, 
    selectedCategory, 
    currentPage, 
    totalPages, 
    useInfiniteScroll, 
    setUseInfiniteScroll 
}) => (
    displayPosts && displayPosts.length > 0 && (
        <div className="d-flex justify-content-between align-items-center mb-3 p-3 bg-light rounded-3">
            <small className="text-muted">
                {selectedCategory ? (
                    <>
                        عدد المقالات في <strong>{selectedCategory.name}</strong> : <span className="posts-count-badge">{displayTotal || 'جاري التحميل...'}</span>
                    </>
                ) : (
                    <>
                        عدد المقالات : <span className="posts-count-badge">{displayTotal || 'جاري التحميل...'}</span>
                    </>
                )}
            </small>
            <div className="d-flex align-items-center gap-3">
                <small className="text-muted">
                    الصفحة <strong>{currentPage}</strong> من <strong>{totalPages || '...'}</strong>
                </small>
                <div className="form-check form-switch infinite-scroll-toggle">
                    <input 
                        className="form-check-input" 
                        type="checkbox" 
                        id="infiniteScrollToggle"
                        checked={useInfiniteScroll}
                        onChange={(e) => setUseInfiniteScroll(e.target.checked)}
                    />
                    <label className="form-check-label small" htmlFor="infiniteScrollToggle">
                        التمرير التلقائي
                    </label>
                </div>
            </div>
        </div>
    )
);

export default PostsCountInfo;
